<template>
  <MglMap
    style="height: 800px; width:100%;"
    ref="map"
    :accessToken="accessToken"
    :mapStyle="mapStyle"
    :center="center"
    :zoom="zoom"
    @load="onMapLoad"
  >
    <MglGeojsonLayer
      :layerId="perimeterLineId"
      :sourceId="sourceId"
      :source="geoJsonSource"
      :layer="geoJsonLineLayer"
    />
    <MglGeojsonLayer
      :layerId="perimeterFillId"
      :sourceId="sourceId"
      :source="geoJsonSource"
      :layer="geoJsonFillLayer"
    />
    <MglNavigationControl position="top-right"/>
    <MglGeolocateControl position="top-right"/>
    <MglMarker
      v-for="marker in markers"
      :key="marker.code"
      :coordinates="marker.position"
      :draggable="draggable"
      color="#ED6D3A"
      ref="markers"
      @dragend="dragEnd"
    />
  </MglMap>
</template>

<script>
import Mapbox from "mapbox-gl";
import {MglMap, MglNavigationControl, MglGeolocateControl, MglMarker, MglPopup, MglGeojsonLayer} from "vue-mapbox";

export default {
  name: "MapboxMap",
  props: {
    center: Array,
    zoom: Number,
    markers: Array,
    perimeter: Array,
    draggable: Boolean
  },
  components: {
    MglMap,
    MglNavigationControl,
    MglGeolocateControl,
    MglMarker,
    MglPopup,
    MglGeojsonLayer
  },
  data() {
    return {
      sourceId: 'perimeterSource',
      perimeterLineId: 'perimeterLineLayer',
      perimeterFillId: 'perimeterFillLayer',
      geoJsonSource1: {
        type: 'geojson',
        data: {
          id: 'perimeterSource',
          type: "FeatureCollection",
          features: [
            {
              type: 'Feature',
              geometry: {
                type: 'Polygon',
                coordinates: [this.polygon]
              }
            }
          ]
        }
      },
      geoJsonLineLayer: {
        type: "line",
        paint: {
          "line-color": "black",
          'line-width': 2
        }
      },
      geoJsonFillLayer: {
        type: "fill",
        paint: {
          'fill-color': '#ED6D3A', // blue color fill
          'fill-opacity': 0.1
        }
      },
      storePerimeter: [],
      defaultMapLayers: null
    };
  },
  computed: {
    accessToken() {
      return this.$store.getters['getParameter']('mapbox').accessToken;
    },
    mapStyle() {
      return this.$store.getters['getParameter']('mapbox').mapStyle;
    },
    polygon() {
      const perimeter = [];
      for (let i = 0; i < this.perimeter.length; i++) {
        perimeter.push([parseFloat(this.perimeter[i].split(',')[0]), parseFloat(this.perimeter[i].split(',')[1])])
      }
      return perimeter;
    },
    geoJsonSource() {
      const perimeter = [];
      for (let i = 0; i < this.perimeter.length; i++) {
        perimeter.push([parseFloat(this.perimeter[i].split(',')[0]), parseFloat(this.perimeter[i].split(',')[1])])
      }
      return {
        type: 'geojson',
        data: {
          id: 'perimeterSource',
          type: "FeatureCollection",
          features: [
            {
              type: 'Feature',
              geometry: {
                type: 'Polygon',
                coordinates: [perimeter]
              }
            }
          ]
        }
      }
    }
  },
  created() {
    this.mapbox = Mapbox;
    this.map = null;
  },
  methods: {
    onMapLoad(event) {
      this.map = event.map;
    },
    setZoom(zoom) {
      this.map.setZoom(zoom);
    },
    setCenter(center) {
      this.map.setCenter(center);
    },
    dragEnd(args) {
      this.$emit('dragend', args);
    }
  }
};
</script>

<style scoped>
#map {
  width: 60vw;
  min-width: 360px;
  text-align: center;
  background-color: #ccc;
}
</style>
